
import { defineComponent, Ref, ref } from 'vue'

import {
  Disclosure,
  DisclosureButton
} from '@headlessui/vue'

type Setup = {
  open: Ref<boolean>
}

export default defineComponent({
  components: {
    Disclosure,
    DisclosureButton
  },
  setup (): Setup {
    const open = ref(false)

    return {
      open
    }
  }
})
